import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const CATEGORY_MENU: PermissionTableRowType = {
  name: '카테고리',
  key: 'CATEGORY_MANAGE',
  subRows: [
    {
      name: '카테고리 생성 관리',
      key: PERMISSION_SUBJECTS.PRODUCT_CATEGORY,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
      ],
    },
    {
      name: '카테고리 전시 관리',
      key: PERMISSION_SUBJECTS.PRODUCT_CATEGORY_EXHIBITION,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.UPDATE],
    },
  ],
};
